import {
    PASSENGER_TYPES,
} from "@/schemas/passengerSchema";

const defaultCheckin = new Date();
defaultCheckin.setDate(defaultCheckin.getDate() + 1);

const defaultCheckout = new Date();
defaultCheckout.setDate(defaultCheckout.getDate() + 4);

// Hotel için default passenger counts
// Hotel passenger types: adult, child
const defaultHotelGuestCounts = {
  [PASSENGER_TYPES.ADULT]: 1,
  [PASSENGER_TYPES.CHILD]: 0,
  childrenAges: [],
};

// Hotel için initial state - sadece gerekli alanlar
export const initialState = {
  loading: false,
  checkinDate: defaultCheckin,
  checkoutDate: defaultCheckout,
  location: null,
  guests: defaultHotelGuestCounts,
  latestHotelSearches: null,
  popularLocations: null,
  publicHolidays: [],
};

export const hotelSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_CHECKIN_DATE":
      return { ...state, checkinDate: action.payload };
    case "SET_CHECKOUT_DATE":
      return { ...state, checkoutDate: action.payload };
    case "SET_LOCATION":
      return { ...state, location: action.payload };
    case "SET_GUESTS":
      return {
        ...state,
        guests: action.payload.guests,
      };
    case "SET_LATEST_HOTEL_SEARCHES":
      return { ...state, latestHotelSearches: action.payload };
    case "SET_POPULAR_LOCATIONS":
      return { ...state, popularLocations: action.payload };
    case "SET_PUBLIC_HOLIDAYS":
      return { ...state, publicHolidays: action.payload };
    default:
      return state;
  }
};

export default hotelSearchReducer;
